module.exports = __webpack_public_path__ + "static/media/12.968f503d.jpg";